/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

'use client';

import { datadogRum } from '@datadog/browser-rum';

const applicationId = process.env.NEXT_PUBLIC_DATADOG_APP_ID;
const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;

if (applicationId && clientToken) {
  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service: 'dbd-stats',
    env: process.env.NODE_ENV,
    sessionSampleRate: 5,
    sessionReplaySampleRate: 1,
    allowFallbackToLocalStorage: true,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}

export const DatadogInit = () => {
  return null;
}
